var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:[_vm.type],style:({marginBottom: _vm.marginBottom}),attrs:{"role":"alert"}},[(_vm.header)?_c('b',{staticStyle:{"margin-right":"0.5em"}},[_vm._t("header",function(){return [_vm._v(_vm._s(_vm.header))]})],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }